/**
 * Size Utilities for Smart Banner - SIMPLE & FLEXIBLE
 * Works with any project, any size format
 */

/**
 * Parse size string to dimensions - ULTRA FLEXIBLE
 * @param {string} sizeString - ANY format: "boyut_360x100", "360x100", "size-300-250", etc.
 * @returns {Object} {width: number, height: number}
 */
export function parseSize(sizeString) {
  // Default fallback
  const defaultSize = { width: 360, height: 100 };

  if (!sizeString) return defaultSize;

  // Extract ALL numbers from ANY format - works with everything
  const numbers = sizeString.match(/(\d+)/g);

  if (numbers && numbers.length >= 2) {
    const width = parseInt(numbers[0], 10);
    const height = parseInt(numbers[1], 10);

    // Accept ANY positive numbers - no limits, maximum flexibility
    if (width > 0 && height > 0) {
      return { width, height };
    }
  }

  return defaultSize;
}

/**
 * Apply size directly to banner element - SIMPLE & RELIABLE
 * No complex CSS injection, just direct styling
 * @param {HTMLElement} bannerElement - Banner element
 * @param {Object} size - Size object {width, height}
 */
export function applySize(bannerElement, size) {
  if (!bannerElement || !size) return;

  // Direct style application - works in ANY project
  bannerElement.style.width = `${size.width}px`;
  bannerElement.style.height = `${size.height}px`;
  bannerElement.style.display = "inline-block";

  // Style the image too
  const img = bannerElement.querySelector("img");
  if (img) {
    img.style.width = "100%";
    img.style.height = "100%";
    img.style.objectFit = "cover";
  }
}

/**
 * Get size from string - combines parsing with common presets
 * @param {string} sizeString - Size string
 * @returns {Object} Size object
 */
export function getSize(sizeString) {
  // Common presets for convenience
  const presets = {
    small: { width: 300, height: 100 },
    medium: { width: 600, height: 200 },
    large: { width: 900, height: 300 },
    leaderboard: { width: 728, height: 90 },
    rectangle: { width: 300, height: 250 },
    banner: { width: 468, height: 60 },
  };

  // Check presets first
  if (presets[sizeString]) {
    return presets[sizeString];
  }

  // Parse any custom format
  return parseSize(sizeString);
}
